import Rails from '@rails/ujs'
import { Turbo } from '@hotwired/turbo-rails'

import '~/channels'
import '~/controllers'
import '~/stylesheets/application.css'

Rails.start()

window.Rails = Rails
window.Turbo = Turbo
